import { SecurityService } from '@/tsApi/auth/security-service'
import { SelfService } from '@/tsApi/auth/self-service'
import { ThirdAuthService } from '@/tsApi/auth/thirdauth-service'
import { PostService } from '@/tsApi/discuss/post-service'
import { ReportService } from '@/tsApi/discuss/report-service'
import { TopicService } from '@/tsApi/discuss/topic-service'
import { CommunicateService } from '@/tsApi/wy/communicate-service'
import { HomeService } from '@/tsApi/wy/home-service'
import { CouponService } from '@/tsApi/wy/coupon-service'
import { PreferenceService } from '@/tsApi/wy/preference-service'
import { UserService } from '@/tsApi/wy/user-service'
import { ShowService } from '@/tsApi/wy/show-service.ts'
import { ProfileService } from '@/tsApi/wy/profile-service.ts'
import { StatsService } from '@/tsApi/wy/stats-service.ts'
import { VideoService } from '@/tsApi/wy/video-service'
import { RedPackService } from '@/tsApi/wy/redpack-service'
import { RedPackActivityService } from '@/tsApi/wy/redpackactivity-service.ts'
import { TechService } from '@/tsApi/wy/tech-service'
import { TechCompareService } from '@/tsApi/wy/techcompare-service'
import { ProductService } from '@/tsApi/wy/product-service'
import { PointService } from '@/tsApi/wy/point-service'
import { InviteService } from '@/tsApi/wy/invite-service.ts'
import { UploadService } from '@/tsApi/wy/upload-service.ts'
import { UserPreferenceService } from '@/tsApi/wy/userpreference-service.ts'
import { PushActivityService } from '@/tsApi/wy/pushactivity-service.ts'
import { CommentTagService } from '@/tsApi/wy/commenttag-service'
import { EventTrackService } from '@/tsApi/event/eventtrack-service.ts'
import { ReportService as WyReportService } from '@/tsApi/wy/report-service.ts'
import { discussClient, eventClient, wyAuthClient, wyClient } from '@/tsApi/service'

export const showService = new ShowService(wyClient)
export const profileService = new ProfileService(wyClient)
export const productService = new ProductService(wyClient)
export const statsService = new StatsService(wyClient)
export const communicateService = new CommunicateService(wyClient)
export const preferenceService = new PreferenceService(wyClient)
export const userService = new UserService(wyClient)
export const homeService = new HomeService(wyClient)
export const couponService = new CouponService(wyClient)
export const videoService = new VideoService(wyClient)
export const topicService = new TopicService(discussClient)
export const postService = new PostService(discussClient)
export const reportService = new ReportService(discussClient)
export const securityService = new SecurityService(wyAuthClient)
export const thirdAuthService = new ThirdAuthService(wyAuthClient)
export const selfService = new SelfService(wyAuthClient)
export const redPackService = new RedPackService(wyClient)
export const redPackActivityService = new RedPackActivityService(wyClient)
export const techService = new TechService(wyClient)
export const techCompareService = new TechCompareService(wyClient)
export const pointService = new PointService(wyClient)
export const inviteService = new InviteService(wyClient)
export const uploadService = new UploadService(wyClient)
export const userPreferenceService = new UserPreferenceService(wyClient)
export const pushActivityService = new PushActivityService(wyClient)
export const commentTagService = new CommentTagService(wyClient)
export const eventTrackService = new EventTrackService(eventClient)
export const wyReportService = new WyReportService(wyClient)

//const adminClient = RpcClient.create({ ...rpcConfig, ...{ app: 'jieyue-admin' } });
